import { appBarClasses } from '@mui/material/AppBar';
import { dialogClasses } from '@mui/material/Dialog';
import { drawerClasses } from '@mui/material/Drawer';
import type { Components } from '@mui/material/styles';

export const safeAreaComponents: Components = {
  MuiAppBar: {
    styleOverrides: {
      positionFixed: {
        paddingTop: 'var(--safe-area-top)',
        paddingLeft: 'var(--safe-area-left)',
        paddingRight: 'var(--safe-area-right)'
      }
    }
  },
  MuiDrawer: {
    styleOverrides: {
      root: {
        [`&.${drawerClasses.anchorTop}:not(.${drawerClasses.docked}) > .${drawerClasses.paper}`]: {
          paddingTop: 'var(--safe-area-top)'
        },
        [`&.${drawerClasses.anchorBottom}:not(.${drawerClasses.docked}) > .${drawerClasses.paper}`]: {
          paddingBottom: 'var(--safe-area-bottom)'
        },
        [`&.${drawerClasses.anchorLeft}:not(.${drawerClasses.docked}) > .${drawerClasses.paper}`]: {
          paddingTop: 'var(--safe-area-top)',
          paddingBottom: 'var(--safe-area-bottom)',
          paddingLeft: 'var(--safe-area-left)'
        },
        [`&.${drawerClasses.anchorRight}:not(.${drawerClasses.docked}) > .${drawerClasses.paper}`]: {
          paddingTop: 'var(--safe-area-top)',
          paddingBottom: 'var(--safe-area-bottom)',
          paddingRight: 'var(--safe-area-right)'
        }
      }
    }
  },
  MuiSnackbar: {
    styleOverrides: {
      root: {
        marginTop: 'var(--safe-area-top)',
        marginBottom: 'var(--safe-area-bottom)'
      }
    }
  },
  MuiDialog: {
    styleOverrides: {
      container: {
        [`&:not(:has(> .${dialogClasses.paperFullScreen}))`]: {
          paddingTop: 'var(--safe-area-top)',
          paddingBottom: 'var(--safe-area-bottom)',
          paddingLeft: 'var(--safe-area-left)',
          paddingRight: 'var(--safe-area-right)'
        }
      },
      paperFullScreen: {
        paddingTop: 'var(--safe-area-top)',
        paddingBottom: 'var(--safe-area-bottom)',
        paddingLeft: 'var(--safe-area-left)',
        paddingRight: 'var(--safe-area-right)',
        [`& > .${appBarClasses.root}:first-of-type`]: {
          marginTop: 'calc(var(--safe-area-top) * -1)',
          paddingTop: 'var(--safe-area-top)'
        }
      }
    }
  }
};

export default safeAreaComponents;
